<template>
  <main>
    <HeaderSection v-if="!isAuthRoute" />
      <RouterView />
    <FooterSection v-if="!isAuthRoute" />
  </main>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import HeaderSection from './layout/HeaderSection.vue';
import FooterSection from './layout/FooterSection.vue';

const route = useRoute();

const isAuthRoute = computed(() => {
  return route.path.startsWith('/bum-masterclass/registration-form') ||
         route.path.startsWith('/mrem-masterclass/registration-form');
});
</script>

<style>
/* Global styles */
</style>
